import { css } from "@emotion/css";
import { space, text, themeTokens, borderWidth, fontSize } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
interface SectionHeadingProps {
    title: string | JSX.Element;
    description?: string | JSX.Element;
}
export default function SectionHeading(props: SectionHeadingProps) {
    return (<div className={sectionHeading}>
            <div className={sectionHeadingTitle}>{props.title}</div>
            {props.description && <div className={sectionHeadingDescription}>{props.description}</div>}
        </div>);
}
const sectionHeadingTitle = css({
    color: themeTokens.color.text.primary,
    font: text.body.regular.large,
    paddingTop: "0.6rem",
    paddingBottom: "0.6rem",
    paddingLeft: space[16],
    paddingRight: space[16],
    "&:not(:last-child)": {
        paddingBottom: space[2],
    },
});
const sectionHeadingDescription = css({
    padding: "0 1rem 0.6rem 1rem",
    fontSize: fontSize.small,
    color: themeTokens.color.text.tertiary,
});
const sectionHeading = css({
    width: "100%",
    marginBottom: "-0.0725rem",
    borderRadius: 0,
    backgroundColor: themeTokens.color.background.secondary.default,
    borderStyle: "solid",
    borderWidth: borderWidth.none,
    borderTopWidth: borderWidth[1],
    borderColor: "var(--dividerLight)",
    paddingBottom: space[1],
});
